import { createReducer, createTypes } from 'reduxsauce';

export const appTypes = createTypes(
  `
      SET_INITIALIZED
    `,
  { prefix: 'APP/' }
);
const INITIAL_STATE = [];

const app = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    initialized: action.initialized,
  };
};

export default createReducer(INITIAL_STATE, {
  [appTypes.SET_INITIALIZED]: app,
});
